(function(){
    angular
        .module('appback')
        .directive('ngAlergias064', alergias064);

        alergias064.$inject = ['ResultadosService','$timeout'];
        function alergias064(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=alergias064.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  sub: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
			            });

			            if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { subanaliticas : [{}] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { subanaliticas : [{}] }};
				            }
				        }

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

	                    scope.valorNormalidad = function(analitica){
				            var resultado = false;
				            if(analitica.valoresnormalidad.interpretacion){
				              for(var cont = 0;cont<analitica.valoresnormalidad.interpretacion.length && !resultado;cont++){
				                if(typeof(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa]) != 'undefined' && ((analitica.valoresnormalidad.interpretacion[cont].from=='' || parseFloat(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa].resultado)>=parseFloat(analitica.valoresnormalidad.interpretacion[cont].from)) && (analitica.valoresnormalidad.interpretacion[cont].to=='' || parseFloat(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa].resultado)<parseFloat(analitica.valoresnormalidad.interpretacion[cont].to)))){
				                  resultado = analitica.valoresnormalidad.interpretacion[cont];
				                }
				              }
				            }
				            return resultado;
				        }

			        });
		        }
          }
      }
})();